var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`${_vm.baseClass}`},[_c('EpbToggle',{class:`${_vm.baseClass}__toggle`,attrs:{"options":_vm.modeOptions},on:{"input":function($event){return _vm.$emit('changeMode', _vm.mode)}},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }